import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { Observable } from 'rxjs';

export enum ShiftExportProperty {
  OvernightStay = 'overnightStay',
  TraineeTransport = 'traineeTransport',
  TfComment = 'tfComment',
}

export enum ActivityExportProperty {
  TfzNumber = 'tfzNumber',
  TrainNumber = 'trainNumber',
  Duration = 'duration',
  ReportedDuration = 'reportedDuration',
}

export interface ShiftExportSettings {
  id?: string;
  organizationalUnitId: string;
  shiftExportProperties: ShiftExportProperty[];
  activityExportProperties: ActivityExportProperty[];
}

export interface UpdateShiftExportSettingsPayload {
  shiftExportProperties?: ShiftExportProperty[];
  activityExportProperties?: ActivityExportProperty[];
}

@Injectable({
  providedIn: 'root',
})
export class ShiftExportSettingsGateway {
  protected readonly config = inject<ConfigOptions>(ConfigService);
  protected readonly http = inject(HttpClient);

  protected readonly path = 'shift-export-settings';

  getSettings(): Observable<ShiftExportSettings> {
    return this.http.get<ShiftExportSettings>(
      `${this.config.host}/${this.path}`,
    );
  }

  updateSettings(
    settings: UpdateShiftExportSettingsPayload,
  ): Observable<ShiftExportSettings> {
    return this.http.patch<ShiftExportSettings>(
      `${this.config.host}/${this.path}`,
      settings,
    );
  }
}
